<template>
  <div class="container">
    <img :src="imgDataUrl" />
    <br />
    <el-button class="pd-8 mt-8" round @click="toggleShow">设置头像</el-button>
    <div class="pd-8">昵称：{{ userinfo.username }}</div>
    <div class="pd-8">手机号：{{ userinfo.phone }}</div>
    <my-upload field="img" @crop-success="cropSuccess" @crop-upload-success="cropUploadSuccess"
      @crop-upload-fail="cropUploadFail" :value="show" :modelValue="show" :width="200" :height="200" url="/api/avator"
      :params="params" :headers="headers" img-format="png" @update:modelValue="UpdateModelValue"></my-upload>
  </div>
</template>
<style scoped>
.pd-8 {
  padding: 8px;
}

.mt-8 {
  margin-top: 8px;
}

.container {
  width: 930px;
}
</style>
<script>
import "../assets/css/common.css";
import "babel-polyfill"; // es6 shim
import myUpload from "vue-image-crop-upload";
export default {
  components: {
    "my-upload": myUpload,
  },
  data() {
    return {
      show: false,
      params: {
        name: "avatar",
      },
      headers: {
        Authorization: localStorage.getItem("Authorization"),
        smail: "*_~",
      },
      imgDataUrl: "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png",
      userinfo: {},
    };
  },
  mounted() {
    this.getUserInfo();
  },
  methods: {
    getUserInfo() {
      this.$http
        .get("/api/userauth/")
        .then((r) => {
          console.log(r);
          this.userinfo = r.data;
          if (r.data.photo != null) {
            this.imgDataUrl = this.GLOBAL.localBaseURL + r.data.photo;
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    toggleShow() {
      this.show = !this.show;
    },
    UpdateModelValue(modelV) {
      //显示隐藏上传控件
      this.show = modelV;
    },
    /**
     * crop success
     *
     * [param] imgDataUrl
     * [param] field
     */
    cropSuccess(imgDataUrl) {
      console.log("-------- crop success --------");
      this.imgDataUrl = imgDataUrl;
    },
    /**
     * upload success
     *
     * [param] jsonData  server api return data, already json encode
     * [param] field
     */
    cropUploadSuccess(jsonData, field) {
      console.log("-------- upload success --------");
      console.log(jsonData);
      console.log("field: " + field);
      //this.imgDataUrl=jsonData.data;
    },
    /**
     * upload fail
     *
     * [param] status    server api return error status, like 500
     * [param] field
     */
    cropUploadFail(status, field) {
      console.log("-------- upload fail --------");
      console.log(status);
      console.log("field: " + field);
    },
  },
};
</script>
